import type { Color, Room } from '../types/game'

type ModalBufferEvent = {
  type: 'modal'
  seq?: number
  id: string
  action: 'open' | 'close'
  target?: Color | 'all'
}

function isModalEvent(value: unknown): value is ModalBufferEvent {
  if (!value || typeof value !== 'object') {
    return false
  }

  const event = value as Record<string, unknown>
  return event.type === 'modal' && typeof event.id === 'string' && (event.action === 'open' || event.action === 'close')
}

export function getLastModalTrigger(room: Room | null, id: string, target: Color | null): ModalBufferEvent | null {
  if (!room?.buffer?.length) {
    return null
  }

  const entries = room.buffer as unknown[]
  for (let index = entries.length - 1; index >= 0; index -= 1) {
    const entry = entries[index]
    if (
      isModalEvent(entry) &&
      entry.id === id &&
      (target === null || entry.target === target || entry.target === 'all')
    ) {
      return entry
    }
  }

  return null
}

export function isModalOpen(room: Room | null, id: string, target: Color | null) {
  return getLastModalTrigger(room, id, target)?.action === 'open'
}
